<template>
  <section class="listing-block">
    <ListingBlockHeader
      :to="viewAllLink && { path: viewAllLink }"
      :title="title"
      :viewAllText="viewAllText"
      :isEmpty="isEmpty"
    >
      <template v-if="$slots.headerActions" #default>
        <slot name="headerActions"></slot>
      </template>
    </ListingBlockHeader>
    <div class="listing-block__inner">
      <slot></slot>
    </div>
  </section>
</template>

<script setup lang="ts">
import ListingBlockHeader from '@/app/components/listing/ListingBlockHeader.vue'

defineProps<{
  title: string
  viewAllLink?: string
  viewAllText?: string
  isEmpty?: boolean
}>()
</script>

<style lang="scss" scoped>
.listing-block {
  --listing-block-number-of-columns: 3;
  --listing-block-items-width-mobile: 312px;

  &__inner {
    display: grid;
    grid-template-columns: repeat(
      var(--listing-block-number-of-columns),
      minmax(0, 1fr)
    );
    grid-gap: 24px;
    // Add space to render action menus.
    padding-bottom: 250px;
    margin-bottom: -250px;

    @media only screen and (max-width: $w-tablet-s) {
      display: flex;
      gap: 16px;
      overflow-x: auto;
      @include hide-horizontal-scrollbar-on-mobile;
      @include full-width;

      & :deep(> *) {
        flex: 0 0 var(--listing-block-items-width-mobile);
      }
    }
  }

  &:last-of-type &__inner {
    padding-bottom: 0;
    margin-bottom: 0;
  }
}
</style>
